module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  })]), _c('div', {
    staticClass: "navs"
  }, [_c('router-link', {
    class: {
      active: _vm.$route.name === 'home'
    },
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("首页")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#feature'
      }
    }
  }, [_vm._v("产品特性")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#function'
      }
    }
  }, [_vm._v("功能组件")]), _c('router-link', {
    class: {
      active: _vm.$route.name === 'price'
    },
    attrs: {
      "to": {
        name: 'price'
      }
    }
  }, [_vm._v("价格")]), _c('a', {
    attrs: {
      "href": "https://help.upyun.com/knowledge-base/cdp-product/",
      "target": "_blank"
    }
  }, [_vm._v("帮助中心")]), _c('router-link', {
    class: {
      active: _vm.$route.name === 'contact'
    },
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("联系我们")])], 1), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langing"
  }, [_c('a', {
    attrs: {
      "href": "http://console.oncdp.com/#/login",
      "target": "_blank"
    }
  }, [_vm._v("登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-892e569c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 51
// module chunks = 0